/**
 * Permissões do módulo Cadastros (produtos).
 */

export const CAD_PRODUTOS = {
  modulo: "cadastros",
  submodulo: "produtos",
};

export const PERM_ACCESS = { ...CAD_PRODUTOS, funcao: "access" };
export const PERM_SOLICITAR = { ...CAD_PRODUTOS, funcao: "solicitar" };
export const PERM_ESTOQUE = { ...CAD_PRODUTOS, funcao: "estoque" };
export const PERM_CONSULTAR = { ...CAD_PRODUTOS, funcao: "consultar" };

/** Equivalente a cadastrosRequireAccess na API. */
export const ANY_PRODUTOS_ACCESS = [
  PERM_ACCESS,
  PERM_SOLICITAR,
  PERM_ESTOQUE,
  PERM_CONSULTAR,
];

/** Fluxo de solicitações (exclui perfil só-consulta SB1). */
export const ANY_WORKFLOW = [PERM_ACCESS, PERM_SOLICITAR, PERM_ESTOQUE];
